export var DefaultCheckDate;
(function (DefaultCheckDate) {
    DefaultCheckDate[DefaultCheckDate["TODAY_TOMORROW"] = 1] = "TODAY_TOMORROW";
    DefaultCheckDate[DefaultCheckDate["FOLLOW_JUMP_LINK_PARAMS"] = 2] = "FOLLOW_JUMP_LINK_PARAMS";
    DefaultCheckDate[DefaultCheckDate["FOLLOW_JUMP_LINK_PARAMS_AND_FILL_MIN_DAYS"] = 3] = "FOLLOW_JUMP_LINK_PARAMS_AND_FILL_MIN_DAYS";
    DefaultCheckDate[DefaultCheckDate["FIXED_CHECK_IN_AND_OUT_DATE"] = 4] = "FIXED_CHECK_IN_AND_OUT_DATE";
})(DefaultCheckDate || (DefaultCheckDate = {}));
